import {Logger} from '@practicegenius/domain/src/common/logger';
import {QueryCache, MutationCache, QueryClient} from '@tanstack/react-query';

export const makeStandardQueryClient = ({logger}: {logger: Logger}) =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        logger.error(`Got uncaught query error for ${query.queryKey}`, error);
      },
    }),
    mutationCache: new MutationCache({
      onError: error => {
        logger.error(`Got uncaught mutation error`, error);
      },
    }),
  });
